import React, { PureComponent, Fragment } from 'react';
import cn from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import { array, number, string, bool, func } from 'prop-types';
import CustomControl from '../CustomControl/CustomControl';
import Icon from '../Icon/Icon';
import { FMessage } from '../../hoc/IntlComponents';

class FlowDomainTableItem extends PureComponent {
  static propTypes = {
    id: string.isRequired,
    title: string.isRequired,
    name: string.isRequired,
    url: string.isRequired,
    onLandingChange: func.isRequired,
    adaptive: number.isRequired,
    checked: array,
    totalCr: number,
    streamCr: number,
    multiple: bool,
    abTest: bool,
  };

  static defaultProps = {
    checked: [0],
    controls: false,
    multiple: true,
  };

  render() {
    const {
      id,
      streamCr,
      adaptive,
      name,
      url,
      checked,
      multiple,
      onLandingChange,
      showStreamCr,
      abTest,
      isParked,
      excludeFromABChecker,
    } = this.props;

    const isChecked = checked.includes(id);

    return (
      <tr>
        <td className="controls">
          {multiple ? (
            <Fragment>
              <CustomControl
                className="custom-control-xs"
                id={`${name}_${id}`}
                name={name}
                value={id}
                checked={isChecked}
                onChange={onLandingChange}
              />
              {!excludeFromABChecker && checked.length === 1 &&
                abTest &&
                !isChecked && (
                  <UncontrolledTooltip placement="right-start" target={`label_for_${name}_${id}`}>
                    <FMessage id="flow.landings-table.ab-test"/>
                  </UncontrolledTooltip>
                )}
            </Fragment>
          ) : (
            <CustomControl
              className="custom-control-xs"
              type="radio"
              id={`${name}_${id}`}
              name={name}
              value={id}
              checked={isChecked}
              onChange={onLandingChange}
            />
          )}
        </td>
        <td className="platform">
          {!isParked &&
            <Fragment>
              <span id={`${name}_${id}_platform`} className="platform-icons">
                <Icon type="monitor" className="is-active landing-icon" />
                <Icon type="mobile" className={cn('landing-icon', { 'is-active': adaptive > 0 })} />
              </span>

              <UncontrolledTooltip placement="right" target={`${name}_${id}_platform`}>
                {adaptive > 0 ?
                  <FMessage id='tooltip.title.responsive'/>
                  :
                  <FMessage id='tooltip.title.non-responsive'/>
                }
              </UncontrolledTooltip>
            </Fragment>
          }
        </td>
        <td>
          <a href={url} target="_blank">
            {url}
          </a>
        </td>
        <td />
        {showStreamCr && <td className="values">{streamCr}</td>}
        <td className="values">&mdash;</td>
      </tr>
    );
  }
}

export default FlowDomainTableItem;
